/*
 * FLOWIK AI poradce dekorů
 * Zmenší nahranou fotku v prohlížeči, pošle ji s katalogem na Cloudflare Worker
 * a vykreslí 3 doporučené dekory. Handly z odpovědi mapuje na katalog ze stránky.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-flowik-ai]');
  if (!root) return;

  var apiUrl = root.dataset.apiUrl;
  var catalogEl = document.querySelector('[data-ai-catalog]');
  var catalog = [];
  try { catalog = JSON.parse(catalogEl ? catalogEl.textContent : '[]'); } catch (e) {}
  var byHandle = {};
  catalog.forEach(function (item) { byHandle[item.handle] = item; });

  var formEl = root.querySelector('[data-ai-form]');
  var dropzone = root.querySelector('[data-ai-dropzone]');
  var dropLabel = root.querySelector('[data-ai-dropzone-label]');
  var fileInput = root.querySelector('[data-ai-file]');
  var preview = root.querySelector('[data-ai-preview]');
  var roomSel = root.querySelector('[data-ai-room]');
  var consent = root.querySelector('[data-ai-consent]');
  var submitBtn = root.querySelector('[data-ai-submit]');
  var loadingEl = root.querySelector('[data-ai-loading]');
  var errorEl = root.querySelector('[data-ai-error]');
  var resultsEl = root.querySelector('[data-ai-results]');
  var cardsEl = root.querySelector('[data-ai-cards]');
  var orderBtn = root.querySelector('[data-ai-order-samples]');
  var restartBtn = root.querySelector('[data-ai-restart]');

  var imageData = null; // { b64, mediaType }

  function updateSubmitState() {
    if (submitBtn) submitBtn.disabled = !(imageData && consent && consent.checked);
  }

  function showError(msg) {
    if (loadingEl) loadingEl.classList.add('is-hidden');
    if (formEl) formEl.classList.remove('is-hidden');
    if (errorEl) { errorEl.textContent = msg; errorEl.classList.remove('is-hidden'); }
  }

  /* Zmenšení fotky přes canvas na max 1024 px, JPEG ~80 % */
  function processFile(file) {
    if (!file || !/^image\/(jpeg|png|webp)$/.test(file.type)) {
      showError('Vyberte prosím fotku ve formátu JPG, PNG nebo WEBP.');
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      showError('Fotka je větší než 10 MB. Zkuste ji prosím zmenšit.');
      return;
    }
    if (errorEl) errorEl.classList.add('is-hidden');

    var img = new Image();
    var url = URL.createObjectURL(file);
    img.onload = function () {
      var MAX = 1024;
      var scale = Math.min(1, MAX / Math.max(img.width, img.height));
      var canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      var dataUrl = canvas.toDataURL('image/jpeg', 0.8);
      imageData = { b64: dataUrl.split(',')[1], mediaType: 'image/jpeg' };
      if (preview) { preview.src = dataUrl; preview.classList.remove('is-hidden'); }
      if (dropLabel) dropLabel.classList.add('is-hidden');
      URL.revokeObjectURL(url);
      updateSubmitState();
    };
    img.onerror = function () {
      URL.revokeObjectURL(url);
      showError('Fotku se nepodařilo načíst. Zkuste prosím jinou.');
    };
    img.src = url;
  }

  if (fileInput) {
    fileInput.addEventListener('change', function () { processFile(this.files[0]); });
  }
  if (dropzone) {
    dropzone.addEventListener('dragover', function (e) { e.preventDefault(); dropzone.classList.add('is-dragover'); });
    dropzone.addEventListener('dragleave', function () { dropzone.classList.remove('is-dragover'); });
    dropzone.addEventListener('drop', function (e) {
      e.preventDefault();
      dropzone.classList.remove('is-dragover');
      if (e.dataTransfer.files.length) processFile(e.dataTransfer.files[0]);
    });
  }
  if (consent) consent.addEventListener('change', updateSubmitState);

  function renderResults(recs) {
    if (!cardsEl) return;
    cardsEl.innerHTML = '';
    var titles = [];
    recs.forEach(function (rec) {
      var item = byHandle[rec.handle];
      if (!item) return;
      titles.push(item.title);
      var card = document.createElement('div');
      card.className = 'flowik-card flowik-ai__card';
      card.innerHTML =
        '<a href="' + item.url + '"><img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '" loading="lazy" style="width:100%;border-radius:8px;aspect-ratio:4/3;object-fit:cover;"></a>' +
        '<h3 style="margin:12px 0 4px;">' + item.title + '</h3>' +
        '<p style="font-size:13px;opacity:.7;margin:0 0 8px;">' + item.kolekce + ' · od ' + item.priceM2 + '/m²</p>' +
        '<p class="flowik-ai__reason"></p>' +
        '<a href="' + item.url + '" class="flowik-btn flowik-btn--secondary" style="margin-top:8px;">Zobrazit dekor</a>';
      card.querySelector('.flowik-ai__reason').textContent = rec.reason;
      cardsEl.appendChild(card);
    });

    /* Předání dekorů formuláři vzorků na homepage */
    try { sessionStorage.setItem('flowik_ai_decors', JSON.stringify(titles)); } catch (e) {}

    if (formEl) formEl.classList.add('is-hidden');
    if (loadingEl) loadingEl.classList.add('is-hidden');
    if (resultsEl) resultsEl.classList.remove('is-hidden');
  }

  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      if (!imageData) return;
      if (!apiUrl) {
        showError('Poradce zatím není propojený se serverem. Zkuste to prosím později, nebo nám pošlete fotku přes kontaktní formulář.');
        return;
      }
      if (errorEl) errorEl.classList.add('is-hidden');
      if (formEl) formEl.classList.add('is-hidden');
      if (loadingEl) loadingEl.classList.remove('is-hidden');

      var payload = {
        image: imageData.b64,
        media_type: imageData.mediaType,
        room_type: roomSel ? roomSel.value : '',
        catalog: catalog.map(function (c) {
          return { handle: c.handle, title: c.title, typ: c.typ, odstin: c.odstin, kolekce: c.kolekce, tagy: c.tagy, popis: c.popis };
        }),
      };

      fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.error) { showError(data.error); return; }
          if (!data.recommendations || data.recommendations.length < 3) {
            showError('Doporučení se nepodařilo vytvořit. Zkuste prosím jinou fotku.');
            return;
          }
          renderResults(data.recommendations);
        })
        .catch(function () {
          showError('Spojení se nezdařilo. Zkontrolujte připojení a zkuste to znovu.');
        });
    });
  }

  if (restartBtn) {
    restartBtn.addEventListener('click', function () {
      imageData = null;
      if (fileInput) fileInput.value = '';
      if (preview) { preview.src = ''; preview.classList.add('is-hidden'); }
      if (dropLabel) dropLabel.classList.remove('is-hidden');
      if (resultsEl) resultsEl.classList.add('is-hidden');
      if (formEl) formEl.classList.remove('is-hidden');
      updateSubmitState();
    });
  }
})();
